import type { ComponentProps, FC, ReactNode } from "react";
import React, { useState } from "react";
import {
    Box,
    IconButton,
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem,
    Tooltip,
} from "@mui/material";
import { Icon } from "../../atoms/Icon/Icon";

export const AccountMenu: FC<{
    tooltip: ReactNode;
    items: {
        onClick: ComponentProps<typeof MenuItem>["onClick"];
        icon: ReactNode;
        text: ReactNode;
        testId: string;
    }[];
}> = ({ tooltip, items = [] }) => {
    const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);

    const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    return (
        <Box sx={{ flexGrow: 0 }} data-testid="account-menu">
            <Tooltip title={tooltip}>
                <IconButton
                    onClick={handleOpenUserMenu}
                    sx={{ p: 0 }}
                    color="inherit"
                    data-testid="account-menu-button"
                >
                    <Icon name="user" />
                </IconButton>
            </Tooltip>
            <Menu
                sx={{ mt: "45px" }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
            >
                {items.map((item, index) => (
                    <MenuItem
                        onClick={item.onClick}
                        key={index}
                        data-testid={item.testId}
                    >
                        <ListItemIcon>{item.icon}</ListItemIcon>
                        <ListItemText>{item.text}</ListItemText>
                    </MenuItem>
                ))}
            </Menu>
        </Box>
    );
};
